// extracted by mini-css-extract-plugin
export default {"container":"loginPage_container__PB5A+","content":"loginPage_content__U0M-C"};